var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataHistogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08333 4.3584C7.08333 3.32286 7.9228 2.4834 8.95833 2.4834H11.0417C12.0772 2.4834 12.9167 3.32286 12.9167 4.3584V5.8334H15.625C16.6605 5.8334 17.5 6.67286 17.5 7.7084V16.8751C17.5 17.2202 17.2202 17.5001 16.875 17.5001H3.125C2.77982 17.5001 2.5 17.2202 2.5 16.8751V10.2084C2.5 9.17286 3.33947 8.3334 4.375 8.3334H7.08333V4.3584ZM8.33333 16.2501H11.6667V4.3584C11.6667 4.01322 11.3868 3.7334 11.0417 3.7334H8.95833C8.61315 3.7334 8.33333 4.01322 8.33333 4.3584V16.2501ZM7.08333 9.5834H4.375C4.02982 9.5834 3.75 9.86322 3.75 10.2084V16.2501H7.08333V9.5834ZM12.9167 16.2501V7.0834H15.625C15.9702 7.0834 16.25 7.36322 16.25 7.7084V16.2501H12.9167Z",
    fill: "#9B9DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataHistogram);
export default __webpack_public_path__ + "static/media/data_histogram.0c87db47432f55966d2f1abd7632a040.svg";
export { ForwardRef as ReactComponent };